module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Crop-7afa68c1955cd51195880613da72037c.svg";